(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["buy-buttons"] && !Shopify.designMode) return;
  try {
    // Product-page Buy now goes straight to checkout through the cart, so bundle parts,
// the free plug and any saved company-invoice attributes stay on the order.
// Company invoice details are opt-in: the small link under Buy now opens the form.
// Only these cart attributes are changed; no order, tax, price or shipping writes.
const ballrBuyStates = new WeakMap();
const ballrInvoiceKeys = ['Invoice company name', 'Invoice billing address', 'Customer VAT / Tax ID'];

async function ballrBuyRequest(url, options) {
  const controller = new AbortController();
  const timeout = setTimeout(() => controller.abort(), 20000);
  try {
    const response = await fetch(url, { credentials: 'same-origin', ...options, signal: controller.signal });
    const result = await response.json();
    if (!response.ok || result.status >= 400) throw new Error('Request not confirmed');
    return result;
  } finally { clearTimeout(timeout); }
}

function ballrBuyState(form) {
  if (!ballrBuyStates.has(form)) ballrBuyStates.set(form, { busy: false, uncertain: false, trigger: null });
  return ballrBuyStates.get(form);
}

function ballrInvoiceDialog(form) {
  const dialog = form.querySelector('[data-ballr-buy-dialog]');
  if (dialog && !dialog.dataset.ballrBound) {
    const state = ballrBuyState(form);
    dialog.dataset.ballrBound = 'true';
    dialog.addEventListener('cancel', event => { if (state.busy) event.preventDefault(); });
    dialog.addEventListener('close', () => { state.trigger?.focus(); });
  }
  return dialog;
}

// company = false: Buy now, keeps whatever invoice details the cart already has.
// company = true: save the three invoice fields first, then continue the same way.
async function ballrBuyContinue(form, company) {
  const state = ballrBuyState(form);
  if (state.busy || state.uncertain) return;
  const dialog = ballrInvoiceDialog(form);
  const scope = company ? dialog : form.querySelector('.ballr-buy-now-wrap');
  if (!dialog || !scope) return;
  const error = scope.querySelector('[data-buy-error]');
  const review = scope.querySelector('[data-buy-review]');
  const progress = scope.querySelector('[data-buy-progress]');
  const fields = company ? Array.from(dialog.querySelectorAll('[data-invoice-key]')) : [];
  const attributes = company ? Object.fromEntries(ballrInvoiceKeys.map(key => [key,
    (fields.find(field => field.dataset.invoiceKey === key)?.value || '').trim(),
  ])) : null;
  if (company && fields.some(field => !field.reportValidity())) return;
  if (!form.reportValidity()) return;
  const component = form.closest('product-form-component');
  const nativeAdd = component.querySelector('[ref="addToCartButton"]');
  if (nativeAdd?.disabled) {
    error.textContent = dialog.dataset.selectionError; error.hidden = false; return;
  }
  // Current products have one Model/Set option. Read the selected option as well
  // as the hidden id so a just-clicked model cannot submit the previous variant.
  const section = component.closest('.shopify-section');
  const pickers = Array.from(section?.querySelectorAll('variant-picker, swatches-variant-picker-component') || []);
  const picker = pickers.find(item => item.dataset.productId === component.dataset.productId) || (pickers.length === 1 ? pickers[0] : null);
  const selected = picker?.querySelector('input:checked[data-variant-id], option:checked[data-variant-id]');
  const productData = new FormData(form);
  if (selected?.dataset.variantId) productData.set('id', selected.dataset.variantId);
  productData.delete('return_to');
  if (!productData.get('id')) {
    error.textContent = dialog.dataset.selectionError; error.hidden = false; return;
  }
  if (form.querySelector('ballr-addon-picker [data-addon-choice]:checked')) {
    if (!window.BallrAddon) { error.textContent = dialog.dataset.selectionError; error.hidden = false; return; }
    try { window.BallrAddon.apply(form, productData); } catch { error.textContent = dialog.dataset.selectionError; error.hidden = false; return; }
  }
  const controls = Array.from(form.querySelectorAll('button, input, textarea, select'));
  const disabledBefore = controls.map(control => control.disabled);
  let addAttempted = false;
  let navigating = false;
  state.busy = true;
  scope.setAttribute('aria-busy', 'true');
  progress.hidden = false;
  error.hidden = true;
  controls.forEach(control => { control.disabled = true; });
  try {
    if (company) {
      const saved = await ballrBuyRequest(dialog.dataset.updateUrl, {
        method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ attributes }),
      });
      if (!Object.entries(attributes).every(([key, value]) => (saved.attributes?.[key] || '') === value)) {
        throw new Error('Invoice data not confirmed');
      }
      fields.forEach(field => { field.value = attributes[field.dataset.invoiceKey]; field.defaultValue = field.value; });
    }
    addAttempted = true;
    await ballrBuyRequest(dialog.dataset.addUrl, {
      method: 'POST', headers: { Accept: 'application/json' }, body: productData,
    });
    // Native POST keeps locale, all existing cart items, the bundle parent and cart attributes.
    const checkout = document.createElement('form');
    checkout.method = 'post'; checkout.action = dialog.dataset.cartUrl;
    const entries = [['checkout', '1'], ...(company ? Object.entries(attributes).map(([key, val]) => [`attributes[${key}]`, val]) : [])];
    for (const [name, value] of entries) {
      const input = document.createElement('input');
      input.type = 'hidden'; input.name = name; input.value = value; checkout.append(input);
    }
    document.body.append(checkout);
    HTMLFormElement.prototype.submit.call(checkout);
    navigating = true;
  } catch {
    error.textContent = addAttempted ? dialog.dataset.addError : dialog.dataset.saveError;
    error.hidden = false;
    if (addAttempted) {
      state.uncertain = true;
      review.hidden = false;
    }
  } finally {
    if (!navigating) {
      controls.forEach((control, i) => { control.disabled = disabledBefore[i]; });
      if (state.uncertain) {
        form.querySelectorAll('[data-ballr-buy-now], [data-buy-action="save"]').forEach(button => { button.disabled = true; });
      }
      state.busy = false;
      scope.removeAttribute('aria-busy');
      progress.hidden = true;
    }
  }
}

document.addEventListener('click', event => {
  const button = event.target.closest?.('[data-ballr-buy-now], [data-ballr-invoice-open], [data-buy-action]');
  if (!button || button.disabled) return;
  const form = button.closest('form');
  const dialog = form && ballrInvoiceDialog(form);
  if (!dialog) return;
  event.preventDefault();
  const state = ballrBuyState(form);
  if (state.busy) return;
  if (button.matches('[data-ballr-buy-now]')) {
    void ballrBuyContinue(form, false);
    return;
  }
  if (button.matches('[data-ballr-invoice-open]')) {
    state.trigger = button;
    dialog.showModal();
    dialog.querySelector('[data-invoice-key]')?.focus();
    return;
  }
  switch (button.dataset.buyAction) {
    case 'back':
    case 'close': dialog.close(); break;
    case 'save': void ballrBuyContinue(form, true); break;
  }
});

// The invoice controls live inside the native product form. Enter in a text
// field must save through this gate, not trigger the form's normal Add to cart.
document.addEventListener('keydown', event => {
  const dialog = event.target.closest?.('[data-ballr-buy-dialog]');
  if (!dialog?.open || event.key !== 'Enter' || event.target.tagName === 'TEXTAREA') return;
  if (event.target.matches('[data-invoice-key]')) {
    event.preventDefault();
    const form = dialog.closest('form');
    if (form) void ballrBuyContinue(form, true);
  }
}, true);
  } catch(e) { console.error(e); }
})();

})();
